<template>
  <div class="leaflet-control text-center" style="max-width: 500px; max-height: 400px; overflow-y: scroll;">
    <b-button v-if="!visible_legend" @click="visible_legend = !visible_legend" class="m-1" variant="outline-light" style="border-radius: 15px;">
      <i class="fa-solid fa-circle-info"></i>
    </b-button>
    <b-button v-if="visible_legend" @click="visible_legend = !visible_legend" class="m-1" variant="outline-danger" style="border-radius: 15px;">
      <i class="fa-solid fa-xmark"></i>
    </b-button>

    <b-collapse v-model="visible_legend" class="mt-2">
      <div class="text-center d-flex justify-content-center">
        <strong class="mb-2" style="font-size:16px" v-html="data.text"></strong>
      </div>

      <div class="d-flex justify-content-start align-items-center pl-2">
        <b-form-checkbox v-model="isAllChecked">Επιλογή / Αφαίρεση όλων</b-form-checkbox>
      </div>

      <div v-if="data.value === 'geolocation'">
        <div v-for="(ll, index) in data" :key="index + 'legend'">
          <div v-if="!array_not_show.includes(index)" class="pl-4">
            <b-form-checkbox
              v-model="checkedItems"
              :value="index"
              class="px-2"
              style="font-size: 12px; text-align: left;"
              @change="onupdateCheckedItems"
            >
              <div class="d-flex">
                <div class="pr-2" style="position: relative;">
                  <img :src="'/img/' + ll.icon" style="width: 20px;" />
                </div>
                ({{ ll.number }}) {{ index }}
              </div>
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <div v-else>
        <div v-for="(ll, index) in data" :key="index + 'legend'">
          <div v-if="!array_not_show.includes(index)" class="pl-4">
            <b-form-checkbox
              v-model="checkedItems"
              :value="index"
              class="px-2"
              style="font-size: 12px; text-align: left;"
              @change="onupdateCheckedItems"
            >
              <div class="d-flex">
                <div class="pr-2" style="position: relative;">
                  <i class="fa-solid fa-location-pin" :style="{'color': ll.color, 'font-size': '20px', 'border': '1rem solid;'}"></i>
                </div>
                ({{ ll.number }}) {{ index }}
              </div>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      visible_legend: true,
      array_not_show: ['text', 'value', 'in_radio_group'],
      checkedItems: []
    };
  },
  computed: {
    isAllChecked: {
      get() {
        const keys = Object.keys(this.data).filter(key => !this.array_not_show.includes(key));
        return this.checkedItems.length === keys.length;
      },
      set(value) {
        if (value) {
          this.checkedItems = Object.keys(this.data).filter(key => !this.array_not_show.includes(key));
        } else {
          this.checkedItems = [];
        }
        this.$emit('update:checkedItems', this.checkedItems);
      }
    }
  },
  watch: {
    data: {
      handler() {
        this.updateCheckedItems();
      },
      immediate: true
    }
  },
  created() {
    this.checkedItems = Object.keys(this.data).filter(key => !this.array_not_show.includes(key));
    this.$emit('update:checkedItems', this.checkedItems);
  },
  methods: {
    updateCheckedItems() {
      this.checkedItems = Object.keys(this.data).filter(key => !this.array_not_show.includes(key));
      this.$emit('update:checkedItems', this.checkedItems);
    },
    onupdateCheckedItems() {
      this.$emit('update:checkedItems', this.checkedItems);
    }
  }
};
</script>

<style>
.box3 {
  padding: 8px;
}
@media screen and (max-width: 730px) {
  .box3 {
    font-size: 14px !important;
    width: 40px;
  }
}
</style>
